import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ICONS } from '../../icons';
import Icon from '../../icons/Icon';
import sendRequest from '../../service/sendRequest';
import { getAdminCompanyLogo, getConsumerCompanyLogo } from '../../utils/companyLogoRequests';

import './CompanyLogo.scss';

function CompanyLogo({ logo, size = 24 }) {
  const [isError, setIsError] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  const serverUrl = useSelector((state) => state.securityNew.serverUrl);
  const { projectName, projectPassword } = useSelector((state) => state.consumer.sonar);

  const isConsumer = !!projectName && !!projectPassword;

  const handleErrorImage = () => {
    setIsError(true);
  };

  const getImage = async (logo) => {
    const response = await sendRequest(
      () =>
        isConsumer
          ? getConsumerCompanyLogo(logo, serverUrl, projectName, projectPassword)
          : getAdminCompanyLogo(logo, serverUrl),
      {
        onError: () => {
          handleErrorImage();
          return;
        },
      },
    );

    loadImage(response.data);
  };

  const loadImage = async (arrayBuffer) => {
    if (arrayBuffer) {
      try {
        const blob = new Blob([arrayBuffer]);
        const url = URL.createObjectURL(blob);

        setImageUrl(url);
      } catch (error) {
        handleErrorImage();
      }
    }
  };

  useEffect(() => {
    if (logo) {
      getImage(logo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logo]);

  useEffect(() => {
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [imageUrl]);

  if (!logo && logo === null) {
    return null;
  }

  return imageUrl && !isError ? (
    <div className='common-company-logo_wrapper' style={{ width: `${size}px`, height: `${size}px` }}>
      <img src={imageUrl} onError={handleErrorImage} alt='Company Logo' className='common-company-logo_image' />
    </div>
  ) : (
    <Icon
      icon={ICONS.NoCompanyLogo}
      className='common-company-logo--empty'
      style={{ width: `${size}px`, height: `${size}px`, flexShrink: 0 }}
      disableCommonColors
      disableCommonStyles
    />
  );
}

export default CompanyLogo;
